import React from 'react'
import { Popover, IconButton, Box } from '@material-ui/core'
import HelpIcon from '@material-ui/icons/Help'

interface Props {}

const Component: React.FC<Props> = ({ children }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <>
      <IconButton aria-describedby={id} color="primary" onClick={handleClick}>
        <HelpIcon fontSize="small" />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        <Box padding={2} style={{ maxWidth: '80vw', maxHeight: '80vh' }}>
          {children}
        </Box>
      </Popover>
    </>
  )
}

export default Component
